/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myLocations: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_LOCATIONS_DONE:
      return { ...state, myLocations: action.data.items };
    case AT.ITEM_DELETE_DONE:
      if (action.itemType === 'Location') {
        return {
          ...state,
          myLocations: R.reject((s: any) => s._id === action.itemId, state.myLocations)
        };
      }

      return state;
    default:
      return state;
  }
}
